import React from 'react';
import { Form, Skeleton } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPen } from '@fortawesome/free-solid-svg-icons';
import {
  SettingsCard,
  CardHeader,
  CardTitle,
  CardTitleText,
  InfoRow,
  InfoLabel,
  InfoValue,
  FormSection,
  StyledInput,
  SaveChangesButton,
  CancelButton,
  ActionButtons,
  ActionIconButton,
} from '../Styles';
import { useTheme } from '../../../context/ThemeContext';
import type { AddressSectionProps } from '../types';

const AddressSection: React.FC<AddressSectionProps> = ({
  user,
  editingSection,
  formData,
  loading,
  profileLoading,
  onEdit,
  onInputChange,
  onSave,
  onCancel,
}) => {
  const { isDarkMode } = useTheme();
  
  return (
    <SettingsCard>
      <CardHeader>
        <CardTitle>
          <FontAwesomeIcon icon={faMapMarkerAlt} style={{ fontSize: 20, color: '#1890ff' }} />
          <CardTitleText level={4}>Business Address</CardTitleText>
        </CardTitle>
        <ActionIconButton
          onClick={profileLoading ? undefined : onEdit}
          iconColor="#2D6CCA"
          style={{ opacity: profileLoading ? 0.5 : 1, cursor: profileLoading ? 'not-allowed' : 'pointer' }}
        >
          <FontAwesomeIcon icon={faPen} fontSize={14} color={isDarkMode ? '#fff' : '#222222'} />
        </ActionIconButton>
      </CardHeader>
      {editingSection !== 'address' ? (
        <InfoRow>
          <FontAwesomeIcon icon={faMapMarkerAlt} style={{ fontSize: 16, color: '#1890ff' }} />
          <InfoLabel>Address:</InfoLabel>
          <InfoValue>
            {profileLoading ? (
              <Skeleton.Input active size="small" style={{ width: 100, height: 20 }} />
            ) : (
              user?.address || 'Location not provided'
            )}
          </InfoValue>
        </InfoRow>
      ) : (
        <FormSection>
          <Form.Item label="Business Address">
            <StyledInput
              name="address"
              value={formData.address}
              onChange={onInputChange}
              placeholder="Enter your business address"
            />
          </Form.Item>
          <ActionButtons>
            <SaveChangesButton icon={<CheckOutlined />} onClick={onSave} loading={loading}>
              Save Changes
            </SaveChangesButton>
            <CancelButton onClick={onCancel}>
              Cancel
            </CancelButton>
          </ActionButtons>
        </FormSection>
      )}
    </SettingsCard>
  );
};

export default React.memo(AddressSection);

